import React from "react"
import FieldTypes from "src/pages/dynamic_forms/Types/FieldTypes"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import TrashCan from "src/pages/dynamic_forms/Utils/TrashCan/TrashCan"
import formReggie from "src/pages/dynamic_forms/Utils/FormReggie"
import paletteEngine from "src/pages/dynamic_forms/Utils/paletteEngine"
import { OverlayTrigger } from "react-bootstrap"
import mobileFriendlyWarning from "src/pages/dynamic_forms/Utils/MobileFriendlyWarning/MobileFriendlyWarning"
import reoccuringText from "src/pages/dynamic_forms/Utils/ReoccuringText"
import "./Section.css"
import "../../DynamicForm.css"

interface Props {
    manageParentState: Function
    handleChange: Function
    field: FieldTypes
    row: number
    col: number
    formManagerField?: boolean
    configField?: boolean
    templateField?: boolean
    remove: Function
    palette: Array<DynamicFormPaletteTypes>
    readOnly?: boolean
}

function Section(props: Props) {

    // console.log("df_FieldSectionField props", props)

    const field = props.field
    const name = field.Name || "Section"
    const templateField = props.templateField
    const formManagerField = props.formManagerField
    const configField = props.configField
    const fieldType = templateField ? "TemplateField" : formManagerField ? "FormMangerField" : configField ? "ConfigField" : "Field"

    return (
        <div className={`DynamicForm${fieldType} DynamicFormSection${fieldType}`} style={{ backgroundColor: `${paletteEngine.getPaletteColor("fieldBackgroundColor")}` }}>
            <div className="DynamicFormFieldHeader">
                {!formManagerField && <div className="DynamicFormFieldHeaderLeft">
                    {/* <p>{name}</p> */}
                </div>}
                <div className="DynamicFormFieldHeaderRight">
                    {templateField && <div className="DynamicFormFieldHeaderRightSettings">
                        <div className="DynamicFormFieldHeaderRightSettingsMultiColumnarWarning">
                            {props.col > 0 &&
                                <OverlayTrigger placement="right" overlay={mobileFriendlyWarning("Rows with multiple columns", reoccuringText.multipleColumnInRowWarningText)}>
                                    <span
                                        className="material-icons"
                                        style={{ color: `${paletteEngine.getPaletteColor("editorConfigMultiColumnsWarningIconColor")}` }}>
                                        priority_high
                                    </span>
                                </OverlayTrigger>}
                        </div>
                        <span className="material-icons DynamicFormFieldHeaderRightSettingsGear"
                            style={{ color: `${paletteEngine.getPaletteColor("editorConfigGearColor")}` }}
                            onClick={() => props.manageParentState([{ key: "configTarget", value: { row: props.row, col: props.col } }])}>
                            settings
                        </span>
                        <TrashCan clickCallback={() => props.remove(field.Type, props.row, props.col, true)} color={`${paletteEngine.getPaletteColor("editorTrashBinColor")}`} />
                    </div>}
                </div>
            </div>
            {!props.formManagerField && <div className="DynamicFormFieldBody">
                <div className="DynamicFormSectionDynamicFormFieldBody">
                    <div className="DynamicFormSectionDynamicFormFieldBodyLeft" style={{ backgroundColor: `${paletteEngine.getPaletteColor("sectionFieldPipes")}` }}></div>
                    <div className="DynamicFormSectionDynamicFormFieldBodyMiddle">
                        <p style={{ color: `${paletteEngine.getPaletteColor("sectionTitleColor")}` }}>{formReggie.restrictChars(name, 40) || "Section"}</p>
                    </div>
                    <div className="DynamicFormSectionDynamicFormFieldBodyRight" style={{ backgroundColor: `${paletteEngine.getPaletteColor("sectionFieldPipes")}` }}></div>
                </div>
            </div>}
        </div>
    )
}

export default Section